import { render, staticRenderFns } from "./IconBeyondTime.vue?vue&type=template&id=5b60d106&"
import script from "./IconBeyondTime.vue?vue&type=script&lang=js&"
export * from "./IconBeyondTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports